// extracted by mini-css-extract-plugin
export default {"header":"style_header__RxAj7","title":"style_title__xG0i1","left":"style_left__LjkLn"};